module.exports = __webpack_public_path__ + "img/core-mix-color-hd.f3e6781d.png";